export default "__VITE_ASSET__CfD1Ul0g__"